export const OWNER_UID = 'LAV8lWghXcNIYq68qccc7ltBLAk2';
